import React from "react";
import { TransformadorOqt } from "..";
import { TextOqt, TextPropertyName, WrapperComponent, SwitchOqt, useDialogNodeContext } from "../..";
import { useEffect } from "react";

const clipboardCopyFields = {
  nombre: (prop) => prop, 
  descripcion: (prop) => prop, 
  transitorio: (prop) => prop, 
  fields: (prop) => {
    return prop.map(field => ({
			idParametro: field.idParametro,
			descripcion: field.descripcion,
			nombre: field.nombre,
			value: {
				idOperacion: field.value.idOperacion,
				tipoTransformacion: field.value.tipoTransformacion,
				valorOrigen: field.value.valorOrigen,
				valorDestino: field.value.valorDestino,
				formula: field.value.formula
			}
    }))
  }, 
};
const clipboardPasteFields = {
  nombre: (prop) => prop, 
  descripcion: (prop) => prop, 
  transitorio: (prop) => prop, 
  fields: (prop, value) => {
    const newFields = prop.reduce((prev, field) => {
      return prev.map(f => {
        if(f.nombre !== field.nombre){
          return f;
        }
        return {
          idParametro: field.idParametro,
          descripcion: field.descripcion,
          nombre: field.nombre,
          value: {
            idOperacion: field.value.idOperacion,
            tipoTransformacion: field.value.tipoTransformacion,
            valorOrigen: field.value.valorOrigen,
            valorDestino: field.value.valorDestino,
            formula: field.value.formula
          }
        }
      });
    }, value);
    return newFields;
  }, 
};

export const FormNodeUI = ({fmk}) => {

  const { clipboard } = useDialogNodeContext();
  useEffect(()=>{
    clipboard.setCopyProps(clipboardCopyFields);
    clipboard.setPasteProps(clipboardPasteFields);
  }, [])

  return (
    <>
      <WrapperComponent caption="Nombre" Field={<TextPropertyName autoFocus name="nombre" formik={fmk} variant="standard" />}/>
      <WrapperComponent caption="Descripción" Field={<TextOqt name="descripcion" formik={fmk} variant="standard" multiline={true}/>}/>
      <WrapperComponent caption="Transitorio" Field={<SwitchOqt name="transitorio" formik={fmk} variant="standard" />}/>
      <TransformadorOqt name="fields" caption="Parámetros" formik={fmk} />
    </>
  )
}